import { render, staticRenderFns } from "./IconAccessToken.vue?vue&type=template&id=156ac102&"
import script from "./IconAccessToken.vue?vue&type=script&lang=ts&"
export * from "./IconAccessToken.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports